import React, { Component } from 'react';
import { Button, message, Radio, Modal } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import moment from 'moment';

const monthFormat = 'YYYY-MM';
const RadioGroup = Radio.Group;
let yearMonth = moment().format(monthFormat)

class Filter extends Component {
    handleChange = (params, key) => {
        params.begin = moment(params.begin).format(monthFormat);
        params.end = moment(params.end).format(monthFormat);
        if(Math.abs(moment(params.begin).diff(params.end,'M')) > 11){
            params.end = moment(params.begin).format(monthFormat);
        }
        this.props.onChange(params, key);
    }

    disabledDate = (current, key) => {
        const { params } = this.props;
        const currentValue = current.valueOf();
        if ( key == 'begin'){
            return current && (currentValue < moment(params.end).add(-11, 'M') || currentValue > moment(params.end));
        }else {
            return current && ( currentValue < moment(params.begin) || currentValue > moment(params.begin).add(11, 'M') );
        }
    };

    render() {
        const { businessList, ...rest } = this.props;
        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const filters = [{
            name: '完成访视月份',
            key: 'begin',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '至',
            key: 'end',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
                disabledDate:current => this.disabledDate(current, 'end')
            }
        }, {
            name: '筛选时间',
            key: 'filterBegin',
            type: 'monthPicker',
        }, {
            name: '至',
            key: 'filterEnd',
            type: 'monthPicker',
        }, {
            name: '随机(入组)时间',
            key: 'randomBegin',
            type: 'monthPicker',
        }, {
            name: '至',
            key: 'randomEnd',
            type: 'monthPicker',
        },{
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption,
            }
        },{
            name: '领域leader',
            key: 'leaderUser',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.user.queryLeaderList,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} onChange={this.handleChange} />
        );
    }
}

class VisitTypeConsumeFte extends Component {
    state = {
        data: [],
        loading: false,
        visible:false,
        isInclude:0,
        sortParams: {},
        businessList:[],
        searchParams: {
            begin: `${yearMonth}`,
            end: `${yearMonth}`,
            lineOfBusiness: '-1',
        },
        curParams: {
            begin: `${yearMonth}`,
            end: `${yearMonth}`,
            lineOfBusiness: '-1',
        },
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    componentDidMount() {
        this.loadData();
        this.queryWithLevelByParams();
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const businessList = res.typeConfigureList.slice();
            businessList.unshift({ typeValue: '所有项目', typeConfigureId: -1 });
            this.setState({ businessList });
        });
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const params = this.splitParams(curParams);
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryInvSiteVisitTypeFte,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {
                ...searchParams,
            },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, curParams, isInclude } = this.state;
        const params = this.splitParams(curParams);
        const url = API_URL.dashboard.exportInvSiteVisitTypeFte;
        this.addToDownloadSite({ ...sortParams, ...params, isInclude }, url, 'Report_Visit_Fte');
        this.setState({visible:false})
    }

    addToDownloadSite = (searchArray, url, type) => {
        const options = {
            method: 'POST',
            url: API_URL.common.startAsynchronousExport,
            data: { type },
            dataType: 'json',
            doneResult: (res) => {
                const { success, asynchronousExportId } = res;
                message.success(success);
                const params = { ...searchArray, asynchronousExportId }
                ExportUtil.export(params, null, url);
            },
        };
        $.sendRequest(options);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getColumns = () => {
        const columns = [{
            title: 'JDE主项目号',
            dataIndex: 'mainCode',
            key: 'mainCode',
            fixed: 'left',
            width: 100,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            fixed: 'left',
            width: 160,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusiness',
            key: 'lineOfBusiness',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 100,
        }, {
            title: '项目分类',
            dataIndex: 'investigationType',
            key: 'investigationType',
            width: 100,
        }, {
            title: '领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 80,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 80,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 100,
        }, {
            title: '项目经理工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 90,
        }, {
            title: '项目经理姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 90,
        }, {
            title: '项目经理主管工号',
            dataIndex: 'leaderCode',
            key: 'leaderCode',
            width: 80,
        }, {
            title: '项目经理主管姓名',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 80,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 90,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 90,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 160,
        }, {
            title: '完成访视月份',
            dataIndex: 'yearMonth',
            key: 'yearMonth',
            width: 90,
        }, {
            title: '访视类型',
            dataIndex: 'visitConfigValue',
            key: 'visitConfigValue',
            width: 120,
        }, {
            title: '该访视类型数量',
            dataIndex: 'visitNum',
            key: 'visitNum',
            width: 105,
        }, {
            title: '实时标准访视数',
            dataIndex: 'standardAmount',
            key: 'standardAmount',
            width: 105,
        }, {
            title: '确认标准访视数',
            dataIndex: 'confirmStandardAmount',
            key: 'confirmStandardAmount',
            width: 105,
        }, {
            title: '项目确认FTE',
            dataIndex: 'fte',
            key: 'fte',
            width: 90,
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    handelsRadioChange = e => {
        this.setState({ isInclude: e.target.value })
    }

    render() {
        const { exportable } = this.props;
        const { data, loading, pagination, searchParams, sortParams, businessList, isInclude, visible } = this.state;
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    businessList={businessList}
                    onChange={this.handleFilterChange}
                    buttons={[
                        exportable ?
                            <Button key="export" type="primary" onClick={() => this.setState({ visible:true })} style={{marginLeft: 8}}>导出</Button>
                        :
                            <Button key="export" disabled={true} style={{marginLeft: 8}}>导出</Button>
                    ]}
                />
                <div style={{marginTop: -20, marginBottom: 4, color: '#ffa500'}}>注：由于数据量过大，页面仅展示其中一个项目一个中心的数据，请导出后查看完整数据</div>
                <TableC
                    data={data}
                    scrollY={500}
                    loading={loading}
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    className="visitTypeConsumeFte"
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
                <Modal
                    title='导出'
                    visible={visible}
                    maskClosable={false}
                    width={350}
                    onOk={this.export}
                    onCancel={() => this.setState({ visible:false })}
                >
                    <div>
                        <span>导出是否包含“患者随机月”：</span>
                        <RadioGroup onChange={e => this.handelsRadioChange(e)} value={isInclude}>
                            <Radio value={1}>是</Radio>
                            <Radio value={0}>否</Radio>
                        </RadioGroup>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default VisitTypeConsumeFte;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/visitTypeConsumeFte.js